// API Configuration
// Configura la URL base de tu API según el entorno

// Detectar si estamos en producción o desarrollo
const isDevelopment = process.env.NODE_ENV === 'development';

// URL del backend
// IIS Express usa: https://localhost:5041
// Desarrollo directo usa: https://localhost:7151;http://localhost:5041
// Producción: URL del servidor de Excurix
export const API_URL = isDevelopment 
  ? 'http://localhost:5041'  // URL de desarrollo (IIS Express)
  : 'https://app.excurix.vylaris.ar/api'; // URL de producción

// Otras configuraciones que puedas necesitar
export const APP_NAME = 'Lavadero App';
export const APP_VERSION = '1.0.0';

// Configuración de timeouts
export const REQUEST_TIMEOUT = 30000; // 30 segundos

// Otras constantes útiles
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
